<div class="spacing--margin-horizontal spacing--margin-top">
  <form [formGroup]="form">
    <div class="spacing--margin-bottom" *ngIf="location$ | async as location">
      <span class="text--small text--h5 label">
        {{ 'feed-profit.settings.company-details.location.label' | translate }}
      </span>
      <div class="spacing--margin-top flex--row flex--nowrap">
        <div class="flex--column">
          <span class="text--small text--gray label">
            {{ 'feed-profit.settings.company-details.location.name' | translate }}
          </span>
          <span class="text--small text--bold label">
            {{ location.name }}
          </span>
        </div>
      </div>
      <div class="spacing--margin-top flex--row flex--nowrap">
        <div class="flex--column">
          <span class="text--small text--gray label">
            {{ 'feed-profit.settings.company-details.location.address' | translate }}
          </span>
          <span class="text--small text--bold label">
            {{ location.street }} {{ location.houseNumber }} {{ location.houseNumberAddition }}
          </span>
        </div>
        <div class="flex--column">
          <span class="text--small text--gray label">
            {{ 'feed-profit.settings.company-details.location.postalcode' | translate }}
          </span>
          <span class="text--small text--bold label">
            {{ location.postalCode }}
          </span>
        </div>
        <div class="flex--column">
          <span class="text--small text--gray label">
            {{ 'feed-profit.settings.company-details.location.city' | translate }}
          </span>
          <span class="text--small text--bold label">
            {{ location.city }}
          </span>
        </div>
      </div>
    </div>

    <mat-divider></mat-divider>

    <div class="spacing--margin-top spacing--margin-bottom">
      <span class="text--small text--h5 label">
        {{ 'feed-profit.settings.company-details.calculation.label' | translate }}
      </span>
      <mat-form-field class="flex__child--auto cause-formfield spacing--margin-top">
        <mat-label>{{ 'feed-profit.detail.baseline.calculation-name' | translate }}</mat-label>
        <input
          matInput
          placeholder="{{ 'feed-profit.detail.baseline.calculation-name' | translate }}"
          data-test="baseline__calculation-name"
          formControlName="name"
        />
      </mat-form-field>

      <mat-form-field class="flex__child--auto cause-formfield spacing--margin-top">
        <mat-label>{{
          'feed-profit.settings.company-details.location.cause' | translate
        }}</mat-label>
        <textarea
          class="cause-field"
          matInput
          rows="3"
          placeholder="{{ 'feed-profit.settings.company-details.location.cause' | translate }}"
          formControlName="cause"
          data-test="feedprofit-settings__cause"
        >
        </textarea>
      </mat-form-field>
      <mat-form-field class="flex__child--auto">
        <mat-label>{{
          'feed-profit.settings.company-details.location.price-setting' | translate
        }}</mat-label>
        <mat-select
          [hideSingleSelectionIndicator]="true"
          placeholder="{{
            'feed-profit.settings.company-details.location.price-setting' | translate
          }}"
          formControlName="priceSetting"
          data-test="feedprofit-settings__price-setting"
        >
          <mat-option *ngFor="let setting of priceSettingOptions" [value]="setting">
            {{ setting }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <mat-divider></mat-divider>

    <!-- A N I M A L S -->
    <div class="spacing--margin-vertical">
      <span class="text--small text--h5 label">
        {{ 'feed-profit.settings.company-details.animals.label' | translate }}
      </span>
      <div class="flex--column spacing--margin-top">
        <mat-form-field class="flex__child--auto">
          <mat-label>{{
            'feed-profit.settings.company-details.animals.number-of-silos' | translate
          }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="1"
            placeholder="{{
              'feed-profit.settings.company-details.animals.number-of-silos' | translate
            }}"
            data-test="feedprofit-settings__number-of-silos"
            formControlName="numberOfSilos"
          />
        </mat-form-field>
        <mat-form-field class="flex__child--auto">
          <mat-label>{{
            'feed-profit.settings.extended-baseline-settings.amountOfGrowFinisher' | translate
          }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            placeholder="{{
              'feed-profit.settings.extended-baseline-settings.amountOfGrowFinisher' | translate
            }}"
            data-test="feedprofit-settings__amountOfGrowFinisher"
            formControlName="amountOfGrowFinisher"
          />
        </mat-form-field>
      </div>
    </div>
    <mat-divider></mat-divider>

    <!-- D I S C O U N T S -->
    <div class="spacing--margin-vertical" *ngIf="discount$ | async as discount">
      <span class="text--small text--h5 label">
        {{ 'feed-profit.settings.company-details.discounts.label' | translate }}
      </span>
      <mat-slide-toggle
        ngDefaultControl
        color="primary"
        [hideIcon]="true"
        formControlName="showDiscounts"
        data-test="feedprofit-settings__show-discounts-switch"
        style="float: right"
      >
        <span class="text--small">{{
          'feed-profit.settings.company-details.discounts.show-discounts-switch' | translate
        }}</span>
      </mat-slide-toggle>
      <ng-container *ngIf="form.controls.showDiscounts.value === true">
        <div class="spacing--margin-top flex--row flex--nowrap">
          <div class="flex--column">
            <span class="text--small text--gray label">
              {{ 'feed-profit.settings.company-details.discounts.bulk' | translate }}<br />({{
                this.currencySymbol
              }})
            </span>
            <span class="text--small text--bold label">
              {{ discount.bulkDiscountPer100Kg }}
            </span>
          </div>
          <div class="flex--column">
            <span class="text--small text--gray label">
              {{ 'feed-profit.settings.company-details.discounts.purchase' | translate }} ({{
                this.currencySymbol
              }})
            </span>
            <span class="text--small text--bold label">
              {{ discount.purchaseDiscountPer100Kg }}
            </span>
          </div>
          <div class="flex--column">
            <span class="text--small text--gray label">
              {{ 'feed-profit.settings.company-details.discounts.deliveryday' | translate }} ({{
                this.currencySymbol
              }})
            </span>
            <span class="text--small text--bold label">
              {{ discount.deliveryDayDiscountPer100Kg }}
            </span>
          </div>
        </div>
        <div class="spacing--margin-top flex--row flex--nowrap">
          <div class="flex--column">
            <span class="text--small text--gray label">
              {{ 'feed-profit.settings.company-details.discounts.payment' | translate }}<br />(%)
            </span>
            <span class="text--small text--bold label">
              {{ discount.paymentDiscountPercentage }}
            </span>
          </div>
          <div class="flex--column">
            <span class="text--small text--gray label">
              {{ 'feed-profit.settings.company-details.discounts.member-benefit' | translate
              }}<br />(%)
            </span>
            <span class="text--small text--bold label">
              {{ discount.memberBenefitDiscountPercentage }}
            </span>
          </div>
          <div class="flex--column">
            <span class="text--small text--gray label">
              {{ 'feed-profit.settings.company-details.discounts.member-discount' | translate }}
              ({{ this.currencySymbol }})
            </span>
            <span class="text--small text--bold label">
              {{ discount.memberDiscountPer100Kg }}
            </span>
          </div>
        </div>
      </ng-container>
    </div>
  </form>
</div>
